import {
    GET_CASH_BANK_LIST,
    GET_CASH_BANK_ENTRIES,
    GET_CASH_BANK_SUMMARY,
    CLEAR_CASH_BANK_STATE,
} from '../../index.types';

export function getCashBankList(data) {
    return { type: GET_CASH_BANK_LIST, data };
}

export function getCashBankEntries(data) {
    return { type: GET_CASH_BANK_ENTRIES, data };
}

export function getCashBankSummary(data) {
    return { type: GET_CASH_BANK_SUMMARY, data };
}

export function clearCashBankState() {
    return { type: CLEAR_CASH_BANK_STATE };
}
